<template>
    <div class="restaurant">
        <cancel></cancel>
        <div class=" start">
            <div class="booking-container-n">

                <div class="page-intro" v-if="content != null">
                    <h1>{{content.Heading}}</h1>
                    <div v-html="content.Intro"></div>
                </div>

               


                <div v-if="!isLoading && configuration != null" class=" mb-5">
                    <div v-if="isDisabled">
                        <div class="row mb-5 ">
                            <div class="col-xl-24 text-center">
                                <div class=" p-3 bg-white" v-html="restaurantStatus.BookingMessage">
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    
                    <div v-else class="row justify-content-center">
                        <div class="mb-5 col-xl-12"
                             v-for="(restaurant, index) in configuration.Restaurants"
                             v-bind:key="restaurant.Key">

                            <div class="h-100 has-shadow bg-white d-flex flex-column">
                                <div class="restaurant-gallery">
                                    <single-image-gallery v-bind:images="restaurant.Images"></single-image-gallery>
                                </div>
                                <div class="p-5 flex-grow-1 d-flex flex-column justify-content-between">
                                    <div>
                                        <h3 class="mb-3">{{restaurant.DisplayName}}</h3>
                                        <div class="mb-3 restaurant-content"
                                             v-html="restaurant.Description"></div>
                                    </div>
                                    <div class="btn-container btn-container--start">
                                        <button class="btn btn--slate-blue btn-restaurant"
                                                type="button"
                                                v-on:click="onBookRestaurant(restaurant)">
                                            Book
                                        </button>

                                        <a v-if="restaurant.MenuLink != null && restaurant.MenuLink.length"
                                                class="btn btn--transparent-dark  btn-restaurant"
                                           v-bind:href="restaurant.MenuLink"
                                                target="_blank">
                                            Sample Menu
                                        </a>


                                    </div>

                                </div>
                            </div>

                        </div>

                    </div>

                </div>

                <div v-if="isLoading" class="d-flex justify-content-center">
                    <loader></loader>
                </div>

            </div>
        </div>
    </div>


</template>

<script>


    import { store } from '../store/index';

    import Cancel from '@/shared/components/Cancel.vue';
    import Loader from '@/shared/components/Loader.vue';
    import SingleImageGallery from '@/shared/components/SingleImageGallery.vue';

    export default {
        name: 'RestaurantList',
        computed: {
            isDisabled() {
     
                return this.restaurantStatus != null && this.restaurantStatus.IsDisabled;
            },
            restaurantStatus() {
                return store.getters.restaurantSystemStatus;

            },
            configuration() {
                return store.getters.configuration;
            },
            content() {
                if (this.configuration != null) {
                    return this.configuration.Landing;
                }
                return null;
            }
        },
        components: {
            Cancel,
            Loader,
            SingleImageGallery
        },
        data() {
            return {
                isLoading: false
            }
        },
        created() {
            this.isLoading = true;
            store.dispatch('clear').then(() => {
                store.dispatch('getConfiguration').then(() => {
                    this.isLoading = false;
                });
            });
        },
        methods: {

            onStart: function () {
                this.isLoading = true;
            },
            onBookRestaurant: function (restaurant) {
                let id = restaurant.Id;
      
                this.$router.push({ name: 'restaurant_booking', params: { id } });
            }
        }
    }
</script>

<style src="@/css/booking/booking.css"></style>
<style>

    .restaurant .start .restaurant-gallery {
        height: 270px;
    }

    .restaurant .start .restaurant-content,
    .restaurant .start .restaurant-content p,
    .restaurant .start .restaurant-content ul,
    .restaurant .start .restaurant-content ul li{
        font-size: 16px !important;
    }

</style>

